import React from 'react';
import PropTypes from 'prop-types';
import {
  Popover, List, ListItem, ListItemAvatar, ListItemText, Divider, ListItemIcon, makeStyles,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import MyAvatar from '../../widgets/avatar/MyAvatar';
import { seedDashboard3DrawersIcons } from '../../icon/seed-icons';
import { dashboard3DrawersIconsPropTypes, d3dPopoverMenusPropTypes, defaultD3dPopoverMenusPropTypes } from './d3d-prop-types';

const useStyles = makeStyles(() => ({
  userMenu: {
    minWidth: 360,
  },
  // mobileUserMenu: {
  //   [theme.breakpoints.up('sm')]: {
  //     display: 'none',
  //   },
  // },
}));

const D3DPopover = (props) => {
  const {
    anchorEl,
    onClose,
    avatar,
    profileTitle,
    profileSubtitle,
    menus,
    onClickLogout,
    icons,
    profilePath,
  } = props;
  const classes = useStyles();

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <div className={classes.userMenu}>
        <List>
          <ListItem button component="a" href={profilePath}>
            <ListItemAvatar>
              <MyAvatar
                src={avatar}
                alt={profileTitle}
                name={profileTitle}
              />
            </ListItemAvatar>
            <ListItemText
              primary={profileTitle}
              secondary={profileSubtitle}
            />
          </ListItem>
          <Divider />
          {/* <ListItem
                  button
                  component="a"
                  href="/notifications"
                  className={classes.mobileUserMenu}>
                    <ListItemIcon>
                      <icons.Notifications />
                    </ListItemIcon>
                    <ListItemText>
                      <FormattedMessage id="dashboard3Drawers.button.notifications" />
                    </ListItemText>
                  </ListItem> */}
          {
            menus.map((menu) => (
              <ListItem
                key={`d3dpopover-menu-${menu.titleId}`}
                button
                component="a"
                href={menu.href}
              >
                <ListItemIcon>
                  <menu.Icon />
                </ListItemIcon>
                <ListItemText>
                  <FormattedMessage id={menu.titleId} />
                </ListItemText>
              </ListItem>
            ))
          }
          <ListItem button onClick={onClickLogout}>
            <ListItemIcon>
              <icons.Input />
            </ListItemIcon>
            <ListItemText>
              <FormattedMessage id="seed.menu.logout" />
            </ListItemText>
          </ListItem>
        </List>
      </div>
    </Popover>
  );
};

D3DPopover.propTypes = {
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  avatar: PropTypes.string,
  profileTitle: PropTypes.string,
  profileSubtitle: PropTypes.string,
  menus: d3dPopoverMenusPropTypes,
  onClickLogout: PropTypes.func.isRequired,
  icons: dashboard3DrawersIconsPropTypes,
  profilePath: PropTypes.string,
};

D3DPopover.defaultProps = {
  anchorEl: undefined,
  avatar: undefined,
  profileTitle: undefined,
  profileSubtitle: undefined,
  menus: defaultD3dPopoverMenusPropTypes,
  icons: seedDashboard3DrawersIcons,
  profilePath: '/profile',
};

export default D3DPopover;
